import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TakeUntilDestroy } from 'src/app/core/decorators';
import { ComparadorService } from 'src/app/core/services/comparador.service';
import { AppStoreActions, AppStoreModel, APP_STATE_TOKEN } from 'src/app/core/store';
import { ProgramaComparador } from 'src/app/core/types/general.type';
import { ROUTES_URL } from 'src/app/core/utils/routes-url';

@Component({
  selector: 'app-comparador-programa',
  templateUrl: './comparador-programa.component.html',
  styleUrls: ['./comparador-programa.component.scss']
})
@TakeUntilDestroy
export class ComparadorProgramaComponent implements OnInit {

  @Select(APP_STATE_TOKEN) appState$: Observable<AppStoreModel>;

  private unsubscribe: any;

  constructor(
    private store: Store,
    private comparadorService: ComparadorService,
    private router: Router) { }

  ngOnInit(): void {
    this.subscribeToState();
  }

  ngOnDestroy() {
    this.comparadorService.openComparador(false);
  }

  private subscribeToState = () => {
    this.store.select<any[]>(s => s.appState.globalConfig.comparador.programas)
      .pipe(takeUntil(this.unsubscribe()))
      .subscribe(programas => {
        this.comparadorService.openComparador(programas.length > 0);
      });
  }

  handleColapsarComparador = (colapsar) => {
    this.comparadorService.colapsarComparador(!colapsar);
  }

  handleDeletePrograma = (item: ProgramaComparador) => {
    this.comparadorService.quitarPrograma(item.idPrograma, item.idUniversidad,item.idModalidadEstudio);
  }

  handleClickComparar = (e) => {
    e.stopPropagation();
    this.router.navigate([ROUTES_URL.COMPARADOR.PROGRAMA]);
  }

  handleClickQuitarTodo = () => {
    const { globalConfig: { comparador: { programas } } } = this.store.selectSnapshot(APP_STATE_TOKEN);

    programas.forEach(item => {
      this.comparadorService.quitarPrograma(item.idPrograma, item.idUniversidad,item.idModalidadEstudio);
    });
  }

}
